export * from "-!../../../../../node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./request.vue?vue&type=template&id=0db9e790&"


//////////////////
// WEBPACK FOOTER
// ./src/templates/components/base/modals/request.vue?vue&type=template&id=0db9e790&
// module id = 1646
// module chunks = 0